export const COURSE_TYPES = 'COURSE_TYPES';  // 课程分类列表
export const HOT_COURSE = 'HOT_COURSE';   // 热门课程
export const SALES_COURSE = 'SALES_COURSE';  // 拼营销课程
export const MANAGE_COURSE = 'MANAGE_COURSE';  // 会管理课程
export const ALL_STUDY_COURSE = 'ALL_STUDY_COURSE';  // 同是们都在学的课程
export const ORG_CITY_COURSE = 'ORG_CITY_COURSE';  // 企业版的课城
